import React, { useState, useEffect, useRef } from "react";
import "./RangeSlider.css";

const RangeSlider = ({ sliderPercentage, percentage, sliderValuesRange, question, questions, isInError }) => {
  const [position, setPosition] = useState(0);
  const [marginLeft, setMarginLeft] = useState(0);
  const [progressBarWidth, setProgressBarWidth] = useState(0);
  const rangeRef = useRef();
  useEffect(() => {
    const thumbWidth = 24;
    const centerThumb = (thumbWidth / 100) * percentage * -1;
    const rangeWidth = rangeRef.current.getBoundingClientRect().width;
    const centerProgressBar = thumbWidth + (rangeWidth / 100) * percentage - (thumbWidth / 100) * percentage;
    setMarginLeft(centerThumb);
    setProgressBarWidth(centerProgressBar);
    setPosition(percentage);
  }, [percentage]);
  return (
    <>
      <div className="sliderContainer">
        <div
          className={"progressBarCover" + (isInError ? " progressBarError" : "")}
          style={{ width: `${progressBarWidth}px` }}
        ></div>
        <div
          className={"thumb" + (isInError ? " progressBarError" : "")}
          style={{ left: `${position}%`, marginLeft: `${marginLeft}px` }}
        ></div>
        <div className="thumb thumb_indicate" style={{ left: `${position}%`, marginLeft: `${marginLeft}px` }}>
          {sliderValuesRange.startValue === "0" && sliderValuesRange.endValue === "10" ? position / 10 : position + "%"}
        </div>
        <input
          type="range"
          className="range"
          onChange={(e) => sliderPercentage(question, e, questions)}
          ref={rangeRef}
        />
      </div>
      <div className="rageValuesContainer">
        <div className="valuesRange">{sliderValuesRange.startValue}</div>
        <div className="valuesRange">{sliderValuesRange.secondValue}</div>
        <div className="valuesRange">{sliderValuesRange.thirdValue}</div>
        <div className="valuesRange">{sliderValuesRange.fourthValue}</div>
        <div className="valuesRange">{sliderValuesRange.fifthValue}</div>
        <div className="valuesRange">{sliderValuesRange.sixthValue}</div>
        <div className="valuesRange">{sliderValuesRange.seventhValue}</div>
        <div className="valuesRange">{sliderValuesRange.eighthValue}</div>
        <div className="valuesRange">{sliderValuesRange.ninthValue}</div>
        <div className="valuesRange">{sliderValuesRange.tenthValue}</div>
        <div className="valuesRange">{sliderValuesRange.endValue}</div>
      </div>
    </>
  );
};

export default RangeSlider;
